<div class="footer">
  <div class="links">
    <div class="linkWrapper"><a class="link" routerLink="/privacy-policy">Privacy Policy</a></div>
    <div class="linkWrapper"><a class="link" routerLink="/terms-and-conditions">Terms &#38; Conditions</a></div>
    <div class="linkWrapper"><a class="link" target="_blank" href="https://g.page/r/CeH8t8maJL7zEB0/review">Leave a Review</a></div>
    <div class="linkWrapper"><a class="link" routerLink="/make-a-complaint">Make a Complaint</a></div>

  </div>

  <br />

  <a target="_blank" href="https://hellobusiness.com.au">
    <span class="copyright">&copy; Hello Business {{ year }}</span>
  </a>
</div>